(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["faq"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', () => {
  // Poistaa turhat <p><br/></p> -elementit, joita Prestige joskus lisää richtext-kentistä
  document.querySelectorAll('.faq .prose p').forEach(p => {
    const html = p.innerHTML.trim();
    if (html === '<br>' || html === '<br/>' || html === '') p.remove();
  });
});

  } catch(e) { console.error(e); }
})();
})();
